import dayjs from 'dayjs'

export function getIsoTime() {
  // includes seconds, miliseconds
  return dayjs().toISOString()
}
